<div class="main-container">
	<app-knowledge-header></app-knowledge-header>
	<app-knowledge-home *ngIf="!kbService.knowledgebaseHomeVisited$.value"></app-knowledge-home>
	<router-outlet name="knowledge-base-modal"></router-outlet>
</div>
